const activateTab = (component, tabIndex) => {
  const triggers = component.querySelectorAll('.impact-tabs__tab-trigger');
  const tabs = component.querySelectorAll('.impact-tab');

  triggers.forEach((trigger, index) => {
    const isActive = index === tabIndex;

    trigger.classList.toggle('active', isActive);
    trigger.setAttribute('aria-selected', String(isActive));
  });

  tabs.forEach((tab, index) => {
    tab.classList.toggle('active', index === tabIndex);
  });
};

const initImpactTabs = (root) => {
  root.querySelectorAll('.impact-tabs').forEach((component) => {
    if (component.dataset.impactTabsInit === 'true') {
      return;
    }

    component.dataset.impactTabsInit = 'true';

    const triggersWrapper = component.querySelector('.impact-tabs__tab-triggers');
    const tabs = component.querySelectorAll('.impact-tab');

    // Build triggers when tabs were rendered by Drupal (no Twig-generated triggers).
    if (triggersWrapper.children.length === 0) {
      tabs.forEach((tab, index) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'impact-tabs__tab-trigger';
        button.setAttribute('role', 'tab');
        button.dataset.tabIndex = String(index);
        button.textContent = tab.querySelector('.tab-title')?.textContent.trim() ?? '';

        triggersWrapper.appendChild(button);
      });

      activateTab(component, 0);
    }
  });
};

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.impact-tabs__tab-trigger');

  if (!trigger) {
    return;
  }

  activateTab(trigger.closest('.impact-tabs'), Number(trigger.dataset.tabIndex));
});

document.addEventListener('DOMContentLoaded', () => {
  initImpactTabs(document);
});

initImpactTabs(document);